import PropTypes from 'prop-types'
import React from 'react'
import StationCarouselItem from '../StationCarouselItem/StationCarouselItem'
import focusable from '../../components/Focusable/Focusable'
import tts from '../../lib/TTS'

export class StationCarousel extends React.Component {
  constructor(props) {
    super(props)
    this.focusedIndex = 0
    this.items = []
    this.state = {
      ready: true,
    }

    this.stationCarouselOuter = React.createRef()
  }

  onKeyEvent(key) {
    let handled = false

    tts.stopRead()
    if (key === 'UP') {
      if (this.items[this.focusedIndex - 1]) {
        this.focusedIndex--
        tts.stopRead()
        this.items[this.focusedIndex]?.setFocus()
        handled = true
      }
    } else if (key === 'DOWN') {
      if (this.items[this.focusedIndex + 1]) {
        this.focusedIndex++
        this.items[this.focusedIndex]?.setFocus()
        handled = true
      }
    }

    return handled
  }

  setChildFocus() {
    if (this.items[this.focusedIndex]) {
      setTimeout(() => {
        this.items[this.focusedIndex]?.setFocus()
      }, 50)
    }
  }

  render() {
    if (!this.state.ready) return null

    const { collection } = this.props
    return (
      <div
        className="station-carousel-container"
        ref={this.stationCarouselOuter}
      >
        {collection && 0 !== collection.length && (
          <>
            {collection.map((r, i) => {
              return (
                <StationCarouselItem
                  parent={this}
                  key={i}
                  index={i}
                  itemCount={collection.length}
                  title={r.title}
                  address={r.address}
                  cid={r.cid}
                  ref={(ref) => {
                    this.items[i] = ref
                    return true
                  }}
                />
              )
            })}
          </>
        )}
      </div>
    )
  }
}

StationCarousel.propTypes = {
  collection: PropTypes.arrayOf(
    PropTypes.shape({
      length: PropTypes.number,
    })
  ),
}

export default focusable(StationCarousel)
